import { Injectable } from "@angular/core";
import { Router, CanActivate } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import * as moment from "moment";
import { ToastController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    public toastController: ToastController,
    public translateService: TranslateService
  ) {}

  canActivate() {
    return true;
    // const token = this.getToken();
    // if (token && token !== '') {
    //     return true;
    // }

    // // not logged in so redirect to login page
    // // this.router.navigate(['/page-tabs/tab5']);
    // this.router.navigate(['/login']);
    // this.presentToast();
    // return false;
  }

  getToken(): string {
    const expiryTime = localStorage.getItem("expiryTime");
    if (expiryTime) {
      const now = moment().valueOf();
      const schExpiryTime = parseInt(expiryTime, 10);
      // console.log(now, typeof now, schExpiryTime, typeof schExpiryTime);
      if (now > schExpiryTime) {
        localStorage.removeItem("token");
        return "";
      } else {
        localStorage.setItem(
          "expiryTime",
          moment().add(30, "m").valueOf().toString()
        );
        const token = localStorage.getItem("token");
        return token;
      }
    }
  }

  async presentToast() {
    const toast = await this.toastController.create({
      message: this.translateService.instant("token过期"),
      duration: 2000,
      position: "top",
      cssClass: "toast_style",
      buttons: [],
    });
    toast.present();
  }
}
